export class LetterPriceDto {

  public readonly id!: string;
  public readonly printSpectrum: 'COLOR' | 'GRAYSCALE' = 'COLOR';
  public readonly printMode: 'SIMPLEX' | 'DUPLEX' = 'SIMPLEX';
  public readonly deliveryProduct: 'FAST' | 'CHEAP' = 'CHEAP';
  public readonly currencyCode: string | undefined;
  public readonly price: number | undefined;
  public readonly sufficientCredit: string | undefined;

  constructor(init?: Partial<LetterPriceDto> | undefined) {
    Object.assign(this, init);
  }
}
